import { constructionAsset, constructionSafety, logisticsAsset } from "@pages/Enterprise/Solution/components/Banner/BannerImages";
import productImg from "../main/product/productImg";
import productPurchase from "../main/product/productPurchase";

export default {
  desc: '4차 산업혁명으로 인해 모든 산업이 재편되고 있는 가운데, 물류 산업도 이러한 변화의 흐름에서 벗어나지 않습니다. 전통적인 공급망 관리 방식은 속도, 정확성, 적응력 면에서 한계를 드러내고 있습니다. 이 시점에서 스마트 물류(Smart Logistics)ㄹ는 필연적인 솔루션으로 떠오르며, 업계의 판도를 완전히 바꿀 잠재력을 보여주고 있습니다. 그렇다면 스마트 물류란 정확히 무엇이며, 왜 공급망의 미래를 위한 열쇠로 여겨지는 걸까요? 이 글에서 자세히 알아보겠습니다.',
  keywords: 'Smart Logistics, 공급망, 창고 관리, IoT, AI, DigitalTwin, Logistics 4.0',
  ogSite: '스마트 물류(Smart Logistics)란 무엇인가?',
  title: '스마트 물류(Smart Logistics)란 무엇인가?',
  ogUrl: 'https://orbro.io/blog/logisticsSolution',
  ogImg: 'https://lh3.googleusercontent.com/fife/ALs6j_EiqaEHW3sGIoGrLDQPblV7l22QDgSLkG9RsMsvdGo25AGD32gDb_xQqdwlunctdetFGmZ6R4xO2SPTRF2-vqpN8oBUUdlcogEppNOKKhsjXk4lEk28VSwyu0ogt2XpQ2WtlMQ6tjV7M_gy1QQZKek5yD8MKhtX8rjaHNeWoSJzhMeFjnpaSjB3i84n3t0T9mtyZ3hVQa1t_XYy7EWjIc6J0jcWe3X7pGvN0hC3h02vv6Q1BFNcn8EFFRfcaXLyCA0fnQUtgB7fcRydJy_Ipu8_VVf1Axiq3G0yMR54nugfMAIJNrwNlF7lB1EmEijPbXc5uxf5TKRXOK7iqXkTPEF6-wbzSmEaQ0-1_Obr2OJ7Qt_sWqi7EeMh4VzFPURZH58s1h_91-qnFA1TewbshOhIHoBqdiFZQY0Taowy2owiJmviQwiYOk0U3iLsfQJhnYE7FcQq0tiKul1q8BtdcLqo23KTOD1NvCyuVUjelS65h-ownOBAg3mgZYwZLv5qsvvP2lTlGNS5-fFRulKhwo2BFlSIM8wfjmpgCIbW4r7uSRWOs-ekMn4AjSRo6y-027G5KzY4w_FYcQLdNOFdXXKki_30c_sYCCLaaRUUTXRs9MwKjlUnIXi8JC3mCUsej517Hn4G1xJoRRbvSx9ZVX8-LrtwX38RnvMAVKUf4R5mC6wdvYD1_gCARuybq5wxXzl_OWHR_YrHFGn7pEdyXRBZt-XoODp0CN2dj35ZUuJPWRDNRYM5sOu5dO9Onu6VFF3Z26o-YHJtchNyNl2_NpokTOibDkvs5cCgiIPPJBpjK6dZ1SnHdbgS8Wzq3PKwLDWawn0SW18dnKfjgQKHXDWkLKpEIELEe0WXdwVw8uGL61BzQPHp2nGoJGTsq-oZ7TJ0IL0yYVp-CIeJKmH35f_eNP2xucN8s3ooq3wVwEgQD5rRz2Try69xEZIJrBnifi2oxOTBLJVx9XnvO6grMU20RAzewYzaPaXwxDMKReuYA5SdH0dTLkyWKnwduJE1QNIqzmB6pvG2ccgSdj78vh-0Xjd8aowwiVgCJX7sbwJ07E5GhWudX6EL7zF-fb6o4_pgt7XgBQ5mawCSyDsadcOz4nf-2jHkP-ibfEEjkiMd31pWP5kr_R3LRJCw02Sm5J5tH7tH7aakn9bxyOfkDUlBYJQ1kdUdKRPx1i6M7_goPhqjdU9UmsTdQO8SWEJzV5ma-dz6Der5vwRecb5ohFKa_lhaecXBUa7Y_X4xO3e_hD-KUcRok0cLvWA8_qEEhVGLzmHUoJLvBbCn9v0VepEORQEXFabgb3w1RuZ-SkzzrcpW9B4A6sQRpI0LPSkC38OvaQK_EUdmkraFLTQF-qMmRDNUVDQ8jmL1zCWc6Tz_fe0GHKCgkZ9TVBCrCWjEK3kPREkaZ7rVHD2qlehDLV0SIvd7k6KjdHyoZ8_0qpBVoVMGYNQCjgLt59VE8HSdZlxMcp-DcERR9NOVgckiuy6osYxoMBhmjg_a6BPK6Wp8tAbDN6x_sV6MZkzxzpTuSbJIyHf25MQKsS0ScDOgo_cnkbxQHG7PTejRCZDPqTeGbxUL5rrdHbYdFqImRWg1PsCOQiUSwFA831UAew0hMHzytmxZ1ObOpH5OecXG8g=w1630-h1416?auditContext=prefetch',
  ogType: 'website',
  date: '2025-06-19',
  tag1: '#SmartLogistics',
  tag2: '#공급망',
  tag3: '#창고관리',
  tag4: '#IoT #AI #DigitalTwin #Logistics40',
  text: [
    {
      head: '',
      subHead: '',
      desc: '4차 산업혁명으로 인해 모든 산업이 재편되고 있는 가운데, 물류 산업도 이러한 변화의 흐름에서 벗어나지 않습니다. 전통적인 공급망 관리 방식은 속도, 정확성, 적응력 면에서 한계를 드러내고 있습니다. 이 시점에서 스마트 물류(Smart Logistics)ㄹ는 필연적인 솔루션으로 떠오르며, 업계의 판도를 완전히 바꿀 잠재력을 보여주고 있습니다. 그렇다면 스마트 물류란 정확히 무엇이며, 왜 공급망의 미래를 위한 열쇠로 여겨지는 걸까요? 이 글에서 자세히 알아보겠습니다.',
      dot: ''
    },
    {
      head: '1. 스마트 물류란 무엇인가?',
      subHead: '',
      desc: '스마트 물류는 단순히 전통적인 물류 프로세스를 디지털화하는 것을 넘어서는 개념입니다. 이는 인공지능(AI), 사물인터넷(IoT), 빅데이터(Big Data), 블록체인과 같은 첨단 기술을 통합하여 연결된 생태계를 구축하며, 지능적이고 자동화된, 투명하며 자체 최적화가 가능한 공급망을 만드는 것입니다.\n창고, 운송 수단, 개별 화물까지 모든 요소가 실시간으로 서로 “대화”하는 공급망을 상상해보세요. 시스템은 수요를 자동으로 예측하고, 혼잡을 피하기 위해 운송 경로를 최적화하며, 화물 상태를 정확히 추적하고, 인간의 개입 없이도 결정을 내릴 수 있습니다. 이것이 바로 스마트 물류의 전반적인 그림입니다.',
      dot: ''
    },
    {
      head: '2. 스마트 물류의 강점을 뒷받침하는 핵심 기술',
      subHead: '',
      desc: '스마트 물류의 “지능”은 다음과 같은 혁신적인 기술을 기반으로 구축됩니다:\n\n사물인터넷(IoT): 트럭, 컨테이너, 팔레트, 심지어 제품 자체에 부착된 센서 장치는 위치, 온도, 습도, 충격 상태 등의 데이터를 지속적으로 수집하고 전송합니다. 이를 통해 화물을 24시간 7일 추적할 수 있으며, 특히 식품이나 의약품과 같은 민감한 품목의 안전성과 품질을 보장합니다.\n\n인공지능(AI) 및 머신러닝(Machine Learning): AI는 시스템의 두뇌 역할을 합니다. IoT가 수집한 방대한 데이터를 분석하여 시장 수요를 정확히 예측하고, 창고 내 상품 배치(warehouse slotting)를 최적화하며, 가장 효율적인 운송 경로를 계획하고, 공급망 내 잠재적 위험을 예측합니다.\n\n빅데이터(Big Data): 공급망의 모든 활동은 엄청난 양의 데이터를 생성합니다. 빅데이터는 기업이 이전에는 볼 수 없었던 패턴, 트렌드, 통찰력을 분석하여 더 나은 전략적 결정을 내리고, 성과를 개선하며, 비용을 절감할 수 있도록 돕습니다.\n\n클라우드 컴퓨팅(Cloud Computing): 데이터 저장, 처리, 어디서나 접근할 수 있는 플랫폼을 제공합니다. 이를 통해 공급망의 모든 이해관계자(제조업체, 공급업체, 운송업체, 고객)가 정보를 원활하고 효율적으로 공유할 수 있습니다.\n\n블록체인(Blockchain): 블록체인 기술은 절대적인 투명성과 보안을 제공합니다. 화물의 각 이동, 모든 거래는 변경 불가능한 “장부”에 기록되어 신뢰를 높이고, 사기를 방지하며, 제품의 원산지 추적을 용이하게 합니다.\n\n디지털 트윈(Digital Twin): 물리적 객체, 프로세스, 심지어 전체 공급망의 디지털 복제본입니다. 디지털 트윈을 통해 기업은 가상 환경에서 시나리오를 시뮬레이션하고, 변경 사항을 테스트하며, 실제 적용 전에 운영을 최적화할 수 있어 위험과 비용을 최소화합니다.',
      dot: ''
    },
    {
      head: '3. 스마트 물류가 가져오는 탁월한 이점',
      subHead: '',
      desc: '스마트 물류의 도입은 단순한 기술 트렌드가 아니라 큰 가치를 창출하는 전략적 투자입니다. 주요 이점은 다음과 같습니다.\n\n효율성 최적화: 창고 관리부터 운송까지의 자동화는 인적 오류를 줄이고, 주문 처리 및 배송 속도를 높입니다.\n\n비용 절감: 지능적인 경로 계획으로 연료를 절약하고, 정확한 재고 관리로 저장 비용을 줄이며, 재고 부족이나 과다 상황을 방지합니다.\n\n투명성 강화: 고객과 기업은 주문의 여정을 실시간으로 추적할 수 있어 신뢰와 계획의 주도성을 높입니다.\n\n고객 경험 향상: 더 빠르고 정확한 배송, 명확한 정보 제공은 디지털 시대에 고객을 만족시키는 핵심 요소입니다.\n\n유연성과 신속한 대응: 시스템은 문제(예: 경로 혼잡)를 빠르게 감지하고 대체 방안을 자동으로 제안하여 예상치 못한 변화에도 공급망이 안정적으로 운영되도록 합니다.',
      dot: ''
    },
    {
      head: '결론',
      subHead: '',
      desc: '스마트 물류는 더 이상 먼 미래의 개념이 아닙니다. 이는 현재 존재하며, 점점 더 치열해지는 시장에서 생존하고 성장하려는 기업에게 필수적인 요구사항이 되고 있습니다. 기술의 힘을 활용함으로써 스마트 물류는 공급망을 비용 중심에서 전략적 경쟁 우위로 전환하여 기업이 더 효율적이고, 지능적이며, 고객과 더 가까운 운영을 가능하게 합니다. 이 모델로의 전환은 미래를 대비하는 필연적인 발걸음입니다.',
      dot: ''
    }
  ],
  
  link: {
    page: 'rtls',
    numb: '2',
    product: [
      {
        text: productPurchase.purchase.worker.workerTracking.title,
        title: productPurchase.purchase.worker.workerTracking.title,
        serial: productPurchase.purchase.worker.workerTracking.serial,
        desc: 'UWB 단말기를 작업자 또는 장비에 부착하여, 실시간으로 위치 추적을 돕는 제품입니다.',
        img: productImg.product.workerTracking.thumbnail,
      },
      {},
    ],

    solution: [
      {
        img: constructionAsset.thumb,
        data: 'constructionAsset',
        link: '/enterprise/construction/asset',
      },
      {
        img: constructionSafety.thumb,
        data: 'constructionSafety',
        link: '/enterprise/construction/safety',
      },
      {
        img: logisticsAsset.thumb,
        data: 'logisticsAsset',
        link: '/enterprise/logistics/asset',
      },
    ],
  },
};
